import { useTranslation } from 'react-i18next';
import { Gift } from 'lucide-react';

interface ReferralCodeAppliedProps {
  code: string;
}

export default function ReferralCodeApplied({ code }: ReferralCodeAppliedProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-green-500/20 backdrop-blur-xl border border-green-500/30 rounded-2xl p-4 flex items-center gap-3">
      <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center shrink-0">
        <Gift className="w-5 h-5 text-green-400" />
      </div>
      <div>
        <p className="text-sm font-medium text-white">{t('referral.applied', 'Referral Code Applied')}</p>
        <p className="text-sm text-green-200">
          {t('referral.appliedDescription', 'Code {{code}} - You\'ll get 1 month free on your first subscription!', { code })}
        </p>
      </div>
    </div>
  );
}
